import { createSelector } from '@ngrx/store';
import { selectWidgetState } from '../../core/core.state';
import { DNContentState, DNFocusContentState, WidgetState } from './widget.model';

export const selectWidgetMedlex = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.medlexContent
);

export const selectWidgetMedlexContent = createSelector(
	selectWidgetMedlex,
	(state: DNContentState) => state?.content
);

export const selectWidgetMinisterialBulletin = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.bulletinContent
);

export const selectWidgetMinisterialBulletinContent = createSelector(
	selectWidgetMinisterialBulletin,
	(state: DNContentState) => state?.content
);

export const selectWidgetAifa = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.aifaContent
);

export const selectWidgetAifaContent = createSelector(
	selectWidgetAifa,
	(state: DNContentState) => state?.content
);

export const selectWidgetInstitutions = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.institutionsContent
);

export const selectWidgetInstitutionsContent = createSelector(
	selectWidgetInstitutions,
	(state: DNContentState) => state?.content
);

export const selectWidgetHighlighted = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.highlightedContent
);

export const selectWidgetHighlightedContent = createSelector(
	selectWidgetHighlighted,
	(state: DNContentState) => state?.content?.[0]
);

export const selectWidgetMostRead = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.mostReadContent
);

export const selectWidgetMostReadContent = createSelector(
	selectWidgetMostRead,
	(state: DNContentState) => state?.content
);

export const selectWidgetLatestNews = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.latestNewsContent
);

export const selectWidgetLatestNewsContent = createSelector(
	selectWidgetLatestNews,
	(state: DNContentState) => state?.content
);

export const selectWidgetRelated = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.relatedContent
);

export const selectWidgetRelatedContent = createSelector(
	selectWidgetRelated,
	(state: DNContentState) => state?.content
);

export const selectWidgetInteresting = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.interestingContent
);

export const selectWidgetInterestingContent = createSelector(
	selectWidgetInteresting,
	(state: DNContentState) => state?.content
);

export const selectWidgetLatestVideos = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.latestVideosContent
);

export const selectWidgetLatestVideosContent = createSelector(
	selectWidgetLatestVideos,
	(state: DNContentState) => state?.content
);

export const selectWidgetFocusArticle = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.focusArticleContent
);

export const selectWidgetFocusMainContent = createSelector(
	selectWidgetFocusArticle,
	(state: DNFocusContentState) => state?.mainContent
);
export const selectWidgetFocusListContent = createSelector(
	selectWidgetFocusArticle,
	(state: DNFocusContentState) => state?.listContent
);

export const selectWidgetFocusVideo = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.focusVideoContent
);

export const selectWidgetFocusVideoMainContent = createSelector(
	selectWidgetFocusVideo,
	(state: DNFocusContentState) => state?.mainContent
);
export const selectWidgetFocusVideoListContent = createSelector(
	selectWidgetFocusVideo,
	(state: DNFocusContentState) => state?.listContent
);

export const selectWidgetInsights = createSelector(
	selectWidgetState,
	(state: WidgetState) => state?.insightsContent
);

export const selectWidgetInsightsContent = createSelector(
	selectWidgetInsights,
	(state: DNContentState) => state?.content
);
